import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import $ from 'jquery';

export default class StickyElement extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sticky: false,
            width: null,
            height: null,
        };

        this.node = null;
        this.contentNode = null;

        this.recalculate = this.recalculate.bind(this);
    }

    componentDidMount() {
        if (this.props.enabled) {
            this.bindEvents();
        }

        this.node = ReactDOM.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
    }

    componentWillUnmount() {
        if (this.props.enabled) {
            this.unbindEvents();
        }

        this.node = null;
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.enabled && nextProps.enabled) {
            this.bindEvents();
        } else if (!nextProps.enabled) {
            this.setState({
                sticky: false,
            });
            this.unbindEvents();
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.props !== nextProps ||
            this.state.sticky != nextState.sticky ||
            this.state.width != nextState.width ||
            this.state.height != nextState.height
        );
    }

    bindEvents() {
        window.addEventListener('touchmove', this.recalculate);
        window.addEventListener('scroll', this.recalculate);
        window.addEventListener('resize', this.recalculate);
    }

    unbindEvents() {
        window.removeEventListener('touchmove', this.recalculate);
        window.removeEventListener('scroll', this.recalculate);
        window.removeEventListener('resize', this.recalculate);
    }

    recalculate() {
        if (!this.node) {
            return;
        }
        const offsetTop = $(this.node).offset().top; // eslint-disable-line react/no-find-dom-node
        const scrollTop = $(document).scrollTop();
        const $content = $(this.contentNode);

        this.setState({
            sticky: this.shouldStick(offsetTop, scrollTop),
            height: $content.innerHeight(),
            width: $content.width(),
        });
    }

    shouldStick(offsetTop, scrollTop) {
        return scrollTop >= offsetTop - 1 - this.props.offsetTop; // -1px to handle scrollTo situations;
    }

    createPlaceholder() {
        var styles = {
            width: this.state.width,
            height: this.state.height,
        };

        return <div className="sticky-element__placeholder" style={styles} />;
    }

    getViewportHeight() {
        return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    }

    getStyles() {
        var styles = {};

        if (this.state.sticky) {
            Object.assign(styles, {
                width: this.state.width,
                position: 'fixed',
                top: this.props.offsetTop,
                zIndex: 2,
            });

            if (this.props.fillViewportHeight) {
                Object.assign(styles, {
                    overflowY: 'auto',
                    maxHeight: this.getViewportHeight(),
                });
            }
        }

        return styles;
    }

    render() {
        var styles = this.getStyles();

        var classes = classNames({
            'sticky-element': true,
            'sticky-element--sticky': this.state.sticky,
        });

        return (
            <div className={classes}>
                {this.state.sticky ? this.createPlaceholder() : ''}
                <div
                    className="sticky-element__content"
                    ref={n => (this.contentNode = n)}
                    style={styles}
                >
                    {this.props.children}
                </div>
            </div>
        );
    }
}

StickyElement.propTypes = {
    children: PropTypes.node.isRequired,
    enabled: PropTypes.bool,
    offsetTop: PropTypes.number,
    fillViewportHeight: PropTypes.bool,
};

StickyElement.defaultProps = {
    enabled: false,
    fillViewportHeight: false,
    offsetTop: 0,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/components/sticky-element.jsx